

import { createBrowserHistory } from "history";

import iconHome from "src/Assets/iconography/sidebar_home.svg";
import iconClients from "src/Assets/iconography/sidebar_mis_clientes.svg";
import iconGroups from "src/Assets/iconography/sidebar_mis_grupos.svg";
import iconCalendar from "src/Assets/iconography/sidebar_calendario.svg";
import iconMessages from "src/Assets/iconography/sidebar_mensajes.svg";
import iconResources from "src/Assets/iconography/sidebar_recursos.svg";

import iconCheck from "src/Assets/iconography/checkcircle_white.svg";

export const menuCoach = [
  {
    title: "Inicio",
    image: iconHome,
    link: "/dashboard",
  },
  {
    title: "Mis Clientes",
    image: iconClients,
    link: "/clients",
  },
  {
    title: "Mis Grupos",
    image: iconGroups,
    link: "/groups",
    isDepartment: false,
  },
  {
    title: "Calendario",
    image: iconCalendar,
    link: "/calendar",
  },
  {
    title: "Mensajes",
    image: iconMessages,
    link: "/messages",
  },
  {
    title: "Recursos",
    image: iconResources,
    link: "/resources",
  },
  {
    title: "Memorándum",
    image: iconCheck,
    link: "/memorandums",
  }
];
export const history = createBrowserHistory();
